//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            
        }
    },
    methods: {
        goSearch(){
            this.$emit('search')
        },
        goQuestion(){
            this.$emit('question')
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/seoTestPage/components/semTopBar.vue